import { FeatureList } from 'core/constants/common';
import Feature from './feature';

export default class DashboardBuilder extends Feature {
  constructor(disabledFeatures: string[]) {
    super(FeatureList.dashboardBuilder, disabledFeatures);
  }

  isAccessible(): boolean {
    return super.isRouteAccessible();
  }
}
